// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_gn-0";
export var optionCard = "_gn-1";